// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5e9a6c19","598":"cef1869c","703":"36a7d379","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};